import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import RegisterPage from './pages/Register';
import LoginPage from './pages/Login';
import ErrorPage from './pages/ErrorPage';
import MapPage from './pages/MapPage';
import PoiFormPage from './pages/LocalPoiFormPage';
import MunicipalityPage from './pages/MunicipalityPage';
import RequireAuth from './components/RequireAuth';
import ViewerMunicipalityPage from './pages/ViewerMunicipalityPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <MapPage />,
  },
  {
    path: '/poi-form',
    element: (
      <RequireAuth fallbackPath={'/login'}>
        <PoiFormPage />
      </RequireAuth>
    ),
  },
  {
    path: '/municipality',
    element: (
      <RequireAuth fallbackPath={'/login'}>
        <MunicipalityPage />
      </RequireAuth>
    ),
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },

  {
    path: '*',
    element: <ErrorPage />,
  },
  {
    path: '/municipality/view',
    element: (
      <RequireAuth fallbackPath={'/login'}>
        <ViewerMunicipalityPage />
      </RequireAuth>
    ),
  },
]);

export default router;
